/*
 * @Descripttion: 组件默认数据模型
 * @Author: zenghua.wang
 * @Date: 2021-05-07 09:15:28
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-04-07 11:28:31
 */

// 字体、图标颜色预定义
// https://blog.csdn.net/wang1qqqq/article/details/94459631
// https://blog.csdn.net/dingxiang1987824/article/details/106362426/?utm_medium=distribute.pc_relevant.none-task-blog-2~default~baidujs_baidulandingword~default-5.control&spm=1001.2101.3001.4242
export const predefineColors = [
  '#3b9cd9',
  '#00ced1',
  '#388498',
  '#3f6899',
  '#d85d2a',
  '#ce2626',
  '#c71585',
  '#ff8c00',
  '#ffd700',
  '#71ae46',
  '#96b744',
  '#c4cc38',
  '#ebe12a'
]

// 主题颜色
export const theme = {
  primary: '#3b9cd9',
  active: '#3b9cd9',
  inactive: '#999',
  showAlpha: true
}

// 组件属性
export const component = {
  basic: '基本属性',
  prop: 'id',
  label: '名称',
  width: '宽度',
  height: '高度',
  left: 'X位置',
  top: 'Y位置',
  zIndex: '组件位置',
  page: '分页设置',
  interface: '接口配置',
  loadingText: '正在加载中...',
  loadingSpinner: 'el-icon-loading',
  loadingBackground: 'rgba(255, 255, 255, 0)',
  // 对齐方式
  alignType: [
    {
      value: 'left',
      label: '左对齐'
    },
    {
      value: 'center',
      label: '居中对齐'
    },
    {
      value: 'right',
      label: '右对齐'
    }
  ],
  // 字体加粗
  weightType: [
    {
      value: 'normal',
      label: 'normal'
    },
    {
      value: 'bold',
      label: 'bold'
    },
    {
      value: 'bolder',
      label: 'bolder'
    },
    {
      value: 'ligter',
      label: 'ligter'
    }
  ],
  // 搜索类型
  searchType: [
    {
      value: 'text',
      label: '文本输入'
    },
    {
      value: 'number',
      label: '数字输入'
    },
    {
      value: 'select',
      label: '下拉'
    },
    {
      value: 'cascader',
      label: '级联下拉'
    },
    {
      value: 'date',
      label: '日期'
    },
    {
      value: 'datetime',
      label: '日期时间'
    },
    {
      value: 'daterange',
      label: '日期范围'
    }
  ],
  // 下拉类型
  selectType: [
    {
      value: '静态',
      label: '静态'
    },
    {
      value: '动态',
      label: '动态'
    }
  ],
  authType: [
    {
      label: '黑名单',
      value: 'black'
    },
    {
      label: '白名单',
      value: 'white'
    }
  ],
  // 特殊组件
  inlineList: ['image', 'progress'],
  // 样式设置
  style: {
    margin: [0, 0, 0, 0],
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    padding: [0, 0, 0, 0, 0],
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    border: [0, 0, 0, 0],
    borderTop: 0,
    borderRight: 0,
    borderBottom: 0,
    borderLeft: 0,
    borderWidth: 0,
    borderStyle: 'solid',
    borderColor: '#e5e4e9'
  },
  // 设计器
  design: {
    padding: '10px',
    bg: '#fff',
    emptyBg: '#f7f7f7',
    solid: '2px solid #e5e4e9',
    activeSolid: '2px solid #3b9cd9',
    dashed: '1px dashed #e5e4e9',
    activeDashed: '1px solid #3b9cd9'
  }
}

// 列表组件属性
export const reportConfig = {
  option: {
    size: 'small',
    rowClassName: '',
    height: 'auto',
    maxHeight: 'auto', // 流体高度
    defaultSort: {},
    showSummary: false,
    showSpan: false
  },
  column: {
    width: 'auto',
    align: 'center',
    color: '#333',
    prop: '',
    label: '',
    type: 'text', // 字段类型
    fixed: false, // 字段固定（left right）
    sortable: false, // 排序
    filterable: false, // 筛选
    filters: [], // 筛选数组
    dicData: [], // 字典
    dicFrom: '静态', // 字典来源
    isColspan: false, // 合并列
    search: false,
    searchKey: null,
    showType: 'show',
    isLink: false, // 添加超链接
    url: '', // url完整地址
    urlType: 'outer', // 外部、内部
    urlPath: '',
    urlParams: [],
    contentAlign: 'center', // 内容
    contentColor: '',
    contentPopover: false,
    // 移动端设置
    isKeywrod: false,
    hideLabel: false,
    hideValue: false,
    valueFontSize: 14,
    valueFontWeight: 'normal',
    valueColor: '#666'
  }
}

// 图表组件属性
export const echartConfig = {
  // 展示类型
  showType: [
    {
      label: '图表名称',
      value: 'name',
      tips: '备注：图表名称仅能选择一个字段；图表数值可选择一个或多个字段；'
    },
    {
      label: '图表数值',
      value: 'value'
    }
  ],
  // 布局朝向
  orients: [
    {
      value: 'horizontal',
      label: '横排'
    },
    {
      value: 'vertical',
      label: '竖排'
    }
  ]
}

// 卡片组件属性
export const cardConfig = {
  attrs: {
    titleFontSize: 14,
    titleFontWeight: 'normal',
    titleColor: '#666',
    textFontSize: 20,
    textFontWeight: 'bold',
    textColor: '#3b9cd9',
    prefixText: '',
    suffixText: '',
    showIcon: false,
    iconSize: 12,
    iconRadius: 2,
    iconPath: '',
    iconColor: '#3b9cd9',
    showPicture: false,
    picture: '',
    isLink: false,
    url: '',
    target: '_self',
    backgroundColor: '#fff',
    opcity: false
  },
  // 展示类型
  showType: [
    {
      label: '标题',
      value: 'name'
    },
    {
      label: '描述',
      value: 'value'
    },
    {
      label: '图片',
      value: 'picture'
    }
  ]
}

// 按钮组件属性
export const buttonConfig = {
  attrs: {
    text: '',
    icon: '',
    size: 'normal',
    plain: false,
    block: false,
    round: false,
    disabled: false,
    fontSize: 14,
    fontWeight: 'normal',
    color: '#fff',
    backgroundColor: '#3b9cd9',
    isLink: false,
    url: '',
    target: '_self'
  }
}

// fdfs图片服务器地址
export const FDFS_WEB_SERVER_URL = window.config.FDFS_WEB_SERVER_URL
